import styled from 'styled-components';

export const Title = styled.span`
  display: flex;
  font-size: 16px;
  line-height: 19px;
  color: #71757f;
`;

export const Input = styled.input`
  display: none;
  & + ${Title} {
    line-height: 22px;
    height: 22px;
    padding-left: 22px;
    display: block;
    position: relative;
    &:not(:empty) {
      padding-left: 30px;
    }
    &:before,
    &:after {
      content: '';
      width: 22px;
      height: 22px;
      display: block;
      border-radius: 50%;
      left: 0;
      top: 0;
      position: absolute;
    }
    &:before {
      background: #d1d7e3;
      transition: background 0.2s ease, transform 0.4s cubic-bezier(0.175, 0.885, 0.32, 2);
    }
    &:after {
      background: #fff;
      transform: scale(0.78);
      transition: transform 0.6s cubic-bezier(0.175, 0.885, 0.32, 1.4);
    }
  }
  &:checked + ${Title} {
    font-weight: 500;
    font-size: 16px;
    line-height: 20px;
    color: #71757f;

    &:before {
      transform: scale(1.04);
      background: #5d9bfb;
    }
    &:after {
      transform: scale(0.4);
      transition: transform 0.3s ease;
    }
  }
`;

export const Label = styled.label`
  display: block;
  cursor: pointer;

  &:hover {
    ${Input} {
      & + ${Title} {
        &:before {
          transform: scale(0.92);
        }
        &:after {
          transform: scale(0.74);
        }
      }
      &:checked + ${Title} {
        &:after {
          transform: scale(0.4);
        }
      }
    }
  }
`;
